module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-panel"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Panel")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-panel', {
    attrs: {
      "title": "标题",
      "desc": "标题描述",
      "status": "状态"
    }
  }, [_c('zan-card', {
    attrs: {
      "title": "商品名称是什么，两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余",
      "desc": "商品SKU1，商品SKU2",
      "thumb": "https://img.yzcdn.cn/upload_files/2017/02/17/FnDwvwHmU-OiqsbjAO5X7wh1KWrR.jpg!100x100.jpg"
    }
  }, [_c('div', {
    staticClass: "zan-card__row",
    slot: "title"
  }, [_c('h4', {
    staticClass: "zan-card__title"
  }, [_vm._v("商品名称是什么，两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余")]), _vm._v(" "), _c('span', {
    staticClass: "zan-card__price"
  }, [_vm._v("¥ 2.00")])]), _vm._v(" "), _c('div', {
    staticClass: "zan-card__row",
    slot: "desc"
  }, [_c('h4', {
    staticClass: "zan-card__desc"
  }, [_vm._v("商品sku")]), _vm._v(" "), _c('span', {
    staticClass: "zan-card__num"
  }, [_vm._v("x 2")])]), _vm._v(" "), _c('div', {
    staticClass: "zan-card__footer",
    slot: "footer"
  }, [_c('zan-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("按钮一")]), _vm._v(" "), _c('zan-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("按钮二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "zan-panel-sum"
  }, [_vm._v("\n      合计："), _c('span', [_vm._v("¥ 1999.90")])])], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("高级用法")]), _vm._v(" "), _c('zan-panel', {
    attrs: {
      "title": "标题",
      "desc": "标题描述",
      "status": "状态"
    }
  }, [_c('zan-card', {
    attrs: {
      "title": "商品名称是什么，两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余",
      "desc": "商品SKU1，商品SKU2",
      "thumb": "https://img.yzcdn.cn/upload_files/2017/02/17/FnDwvwHmU-OiqsbjAO5X7wh1KWrR.jpg!100x100.jpg"
    }
  }, [_c('div', {
    staticClass: "zan-card__row",
    slot: "title"
  }, [_c('h4', {
    staticClass: "zan-card__title"
  }, [_vm._v("商品名称是什么，两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余两行显示状态如效果图，多余多余多余")]), _vm._v(" "), _c('span', {
    staticClass: "zan-card__price"
  }, [_vm._v("¥ 2.00")])]), _vm._v(" "), _c('div', {
    staticClass: "zan-card__row",
    slot: "desc"
  }, [_c('h4', {
    staticClass: "zan-card__desc"
  }, [_vm._v("商品sku")]), _vm._v(" "), _c('span', {
    staticClass: "zan-card__num"
  }, [_vm._v("x 2")])]), _vm._v(" "), _c('div', {
    staticClass: "zan-card__footer",
    slot: "footer"
  }, [_c('zan-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("按钮一")]), _vm._v(" "), _c('zan-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("按钮二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "zan-panel-sum"
  }, [_vm._v("\n      合计："), _c('span', [_vm._v("¥ 1999.90")])]), _vm._v(" "), _c('div', {
    staticClass: "zan-panel-buttons",
    slot: "footer"
  }, [_c('zan-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("按钮一")]), _vm._v(" "), _c('zan-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("按钮二")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d78453ce!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/panel.vue
// module id = 310
// module chunks = 0